import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchRVMTemplate,
  deleteRVMTemplate,
  updateRVMTemplate,
  createTestRVM
} from "../actions/index";
import RVMTemplatesForm from "./RVMTemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";

class RVMTemplatesEditInline extends Component {
  static propTypes = {
    fetchRVMTemplate: PropTypes.func.isRequired,
    deleteRVMTemplate: PropTypes.func.isRequired,
    updateRVMTemplate: PropTypes.func.isRequired,
    handleUpdateRVMId: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    rvmTemplate: PropTypes.object,
    rvm_template_id: PropTypes.number,
    id: PropTypes.number,
    createTestRVM: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchRVMTemplate(
      this.props.rvm_template_id
    );
  }

  sendTestRVM(state) {
    this.props
      .createTestRVM(state)
      .then(response => {
        if (response.payload.status == 200) {
          toastr.success("Test voicemail queued to send");
        }
      });
  }

  onSubmit(state) {
    this.props
      .updateRVMTemplate(
        this.props.rvm_template_id,
        state
      )
      .then(response => {
        if (response.payload.status == "200") {
          toastr.success("Voicemail Template saved!");
          this.props.fetchRVMTemplate(
            this.props.rvm_template_id
          );
          this.props.handleUpdateRVMId(response.payload.data.data.id);
        }
      });
  }

  render() {
    const { rvmTemplate } = this.props;
    if (!rvmTemplate || !rvmTemplate.data) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }

    return (
      <div className="m-b-40">
        <RVMTemplatesForm
          key={rvmTemplate.data.id}
          handleSubmit={this.onSubmit.bind(this)}
          mode="edit"
          inline="true"
          categories={rvmTemplate.data.categories}
          handleSendTestRVM={this.sendTestRVM.bind(this)}
          rvm_template_category_id={rvmTemplate.data.rvm_template_category_id}
          match={this.props.match}
          name={rvmTemplate.data.name}
          body_text={rvmTemplate.data.body_text}
          s3_url={rvmTemplate.data.s3_url}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { rvmTemplate: state.rvmTemplates.rvmTemplate };
}

export default connect(
  mapStateToProps,
  { fetchRVMTemplate, updateRVMTemplate, deleteRVMTemplate, createTestRVM }
)(RVMTemplatesEditInline);
